import React from 'react';
import { certifications } from '../data/mock';
import { Award, Calendar } from 'lucide-react';
import '../styles/Certifications.css';

const Certifications = () => {
  return (
    <section className="certifications-section" id="certifications">
      <div className="certifications-container">
        <h2 className="section-title">Certifications & Achievements</h2>
        
        <div className="certifications-grid">
          {certifications.map((cert) => (
            <div key={cert.id} className={`certification-card ${cert.image ? 'with-image' : ''}`}>
              {cert.image ? (
                <div className="certification-image-wrapper">
                  <img src={cert.image} alt={cert.name} className="certification-image" />
                </div>
              ) : (
                <>
                  <div className="certification-icon">
                    <Award size={24} />
                  </div>
                  
                  <div className="certification-content">
                    <h3 className="certification-name">{cert.name}</h3>
                    <p className="certification-issuer">{cert.issuer}</p>
                    <div className="certification-date">
                      <Calendar size={14} />
                      <span>{cert.date}</span>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;